import {useDispatch, useSelector} from "react-redux";
import ExitButton from "../buttons/ExitButton";
import ToggleSwitchButton from "../buttons/ToggleSwitchButton";
import {FunctionalModal} from "./FunctionalModal";
import React, {useState} from "react";
import styled from "styled-components";
import {BaseModal} from "./modalStyle";
import {GreenButton} from "../buttons/ButtonStyles";
import {loadProject, patchProject} from "../project/one-project/projectAction";

const EditBudgetModal = ({setOpenEditModal}) => {

    const dispatch = useDispatch();
    const {
        realInvestmentBudget,
        realExploitationBudget,
        estimatedInvestmentBudget,
        estimatedExploitationBudget,
        id,
        isBudgetOptional
    } = useSelector(state => state.project)

    const [isOptional, setIsOptional] = useState(isBudgetOptional)
    const [counterRealInvestment, setCounterRealInvestment] = useState(realInvestmentBudget)
    const [counterRealExploitation, setCounterRealExploitation] = useState(realExploitationBudget)
    const [counterEstimatedInvestment, setCounterEstimatedInvestment] = useState(estimatedInvestmentBudget)
    const [counterEstimatedExploitation, setCounterEstimatedExploitation] = useState(estimatedExploitationBudget)
    const handleSubmit = async (e) =>{
        e.preventDefault();
        const newData = {"realInvestmentBudget" : counterRealInvestment,
            "estimatedInvestmentBudget": counterEstimatedInvestment,
            "realExploitationBudget": counterRealExploitation,
            "estimatedExploitationBudget": counterEstimatedExploitation,
            "isBudgetOptional": isOptional,
        }

        await dispatch(patchProject(id, newData))
        await dispatch(loadProject(id))
        closeUpdate();
    }
    const handleChange = (e) => {
        const {name, value} = e.target

        if (name === "realInvestmentBudget"){
            setCounterRealInvestment(value)
        }
        if (name === "estimatedInvestmentBudget"){
            setCounterEstimatedInvestment(value)
        }
        if (name === "realExploitationBudget"){
            setCounterRealExploitation(value)
        }
        if (name === "estimatedExploitationBudget"){
            setCounterEstimatedExploitation(value)
        }
    }
    const toggleChange = () => {
        setIsOptional(!isOptional)
    }
    const closeUpdate = () => {
        setOpenEditModal(false)
    }
    const displayModal = () => {
        return (
            <Modal>
                <NameSection>
                    <h1> Modifier les budgets </h1>
                    <ExitButton
                        closeUpdate={closeUpdate}
                    />
                </NameSection>
                <Container>
                    <Form id={"edit-counter-form"} onSubmit={handleSubmit}>
                        <div className={"flex-row ai-center gap-05"}>
                            <p> Avec budget </p>
                            <ToggleSwitchButton
                                onChange={toggleChange}
                                name={"Budget investissement"}
                                checked={!isOptional}/>
                        </div>
                        {!isOptional &&
                            <>
                                <BudgetContainer>
                                    <h2>Investissement</h2>

                                    <BudgetInputContainer>
                                        <label htmlFor="realInvestmentBudget">
                                            Réel
                                            <input name="realInvestmentBudget" type="number" min="0" onChange={handleChange} value={counterRealInvestment}/>
                                        </label>
                                        <label htmlFor="estimatedInvestmentBudget">
                                            Prévisionnel
                                            <input name="estimatedInvestmentBudget" type="number" min="0" onChange={handleChange} value={counterEstimatedInvestment}/>
                                        </label>
                                    </BudgetInputContainer>
                                </BudgetContainer>
                                <BudgetContainer>
                                    <h2>Exploitation</h2>
                                    <BudgetInputContainer>

                                        <label htmlFor="realExploitationBudget">
                                            Réel
                                            <input name="realExploitationBudget" type="number" min="0" onChange={handleChange} value={counterRealExploitation}/>
                                        </label>
                                        <label htmlFor="estimatedExploitationBudget">
                                            Prévisionnel
                                            <input name="estimatedExploitationBudget" type="number" min="0" onChange={handleChange} value={counterEstimatedExploitation}/>
                                        </label>
                                    </BudgetInputContainer>
                                    </BudgetContainer>
                            </>
                        }

                        <Button form='edit-counter-form' type="submit">
                            <h6> Modifier </h6>
                        </Button>
                    </Form>
                </Container>
            </Modal>
        )
    }
    return (
        <FunctionalModal setOpen={setOpenEditModal} component={displayModal()}/>
    )
}

const Modal = styled(BaseModal)`
  justify-content: space-between;
  width: 95%;
  height: 500px;
  padding: 2em 2em;
  position: fixed;
  gap: 1em;
  
  @media (min-width: 500px) {
    width: 500px;
    left: 0;
    right: 0;
    margin-left: auto ;
    margin-right: auto;
    height: 400px;
  }
  
`

const BudgetContainer = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`

const BudgetInputContainer = styled.div`

  display: flex;
  .label{
    flex-direction: column;
  }
  align-items: center;
  input{
    padding: 0.4rem;
    border: none;
    border-radius: 5px;
    background-color: #cfcfcf;
  }
  
`
const NameSection = styled.div`
  display: flex;
  flex-direction: row;

  h1 {
    width: 90%;
  }

  .exit-btn {
    position: absolute;
    top: 5px;
    right: 15px;
  }
`
const Container = styled.div`
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1em;

  p {
    text-align: center;
  }
`
const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: 1em;
  height: 100%;
  

`

const Button = styled(GreenButton)`
  width: 10em;
  height: 3em;
`

export default EditBudgetModal